import { Component, OnInit, NgZone, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
//import { NetworkServicesService } from 'src/app/networkCalls/network-services.service';
import { Title, Meta } from '@angular/platform-browser';
// import { katanaInput } from 'src/app/models/katana-input.service';
// import { katanaResult } from 'src/app/models/katana-result.service';
// import { CKEditorComponent } from 'ngx-ckeditor';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
//import { Observable, from } from 'rxjs';
// import { MatDialog } from '@angular/material';
// import { ErrorModalComponent } from '../error-modal/error-modal.component';
// import { ProgressStatusService } from '../../services/progress-status-service'
//import { rejectError } from 'src/app/models/reject-suggetions.service';
// import { NGXLogger } from 'ngx-logger';
// import { acceptError } from 'src/app/models/accept-suggetions.service';
// import { trigger, transition, style } from '@angular/animations';
// import { $ } from 'protractor';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
//import { MatRadioChange } from '@angular/material/radio';
//import { start } from 'repl';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-sentence-checker',
  templateUrl: './sentence-checker.component.html',
  styleUrls: ['./sentence-checker.component.scss']
})
export class SentenceCheckerComponent implements  OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    // public dialog: MatDialog,
    // public progressStatusService: ProgressStatusService,
    // private errorModalComponent: ErrorModalComponent,
    public lc: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object
    // private logger: NGXLogger,
  ) {
    //window.addEventListener("message", (d)=>{this.listenWindowMessage(d)});
  }

  ngOnInit() {
    // ele.classList.remove("loading")
    this.titleService.setTitle("Sentence Checker | Free AI Grammar and Sentence Check Online");
    this.metaTagService.updateTag({ name: 'description', content: "Improve your writing with our free AI-powered sentence checker. Instantly detect grammar and sentence structure errors for clear, polished content." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Sentence Checker | Free AI Grammar and Sentence Check Online" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Improve your writing with our free AI-powered sentence checker. Instantly detect grammar and sentence structure errors for clear, polished content." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/sentence-checker' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/WritingMoreEffective.png' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Sentence Checker | Free AI Grammar and Sentence Check Online' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Improve your writing with our free AI-powered sentence checker. Instantly detect grammar and sentence structure errors for clear, polished content." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/WritingMoreEffective.png' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/sentence-checker' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/sentence-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/sentence-checker' });
    if (isPlatformBrowser(this.platformId)) {
      if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");
        return 'Opera';

      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        $("#GCChromeButton").css("display", "block");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");
        return 'Chrome';

      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");

        return 'Safari';

      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "block");
        $("#GCEdgeButton").css("display", "none");
        return 'Firefox';

      }
      else if ((navigator.userAgent.indexOf("MSIE") != -1)) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "block");
        return 'IE';
      }
      else {
        return 'unknown';
      }
    }

    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {"@context":"https://schema.org","@graph":[{"@type":"Product","name":"Sentence Checker","image":"https://www.trinka.ai/assets/images/WritingMoreEffective.png","description":"Improve your writing with our free AI-powered sentence checker. Instantly detect grammar and sentence structure errors for clear, polished content.","brand":{"@type":"Brand","name":"Trinka AI"},"offers":{"@type":"Offer","url":"https://www.trinka.ai/pricing","priceCurrency":"USD","price":"0","priceValidUntil":"2030-12-31","availability":"InStock","hasMerchantReturnPolicy":{"@type":"MerchantReturnPolicy","url":"https://www.trinka.ai/termsofservices","returnPolicyCategory":"https://schema.org/MerchantReturnNotPermitted","applicableCountry":"GL"},"shippingDetails":{"@type":"OfferShippingDetails","shippingDestination":{"@type":"DefinedRegion","addressCountry":"ALL"},"shippingRate":{"@type":"MonetaryAmount","value":"0","currency":"USD"},"deliveryTime":{"@type":"ShippingDeliveryTime","handlingTime":{"@type":"QuantitativeValue","minValue":1,"maxValue":1,"unitCode":"d"},"transitTime":{"@type":"QuantitativeValue","minValue":1,"maxValue":1,"unitCode":"d"}}}},"aggregateRating":{"@type":"AggregateRating","ratingValue":"4.8","reviewCount":"189"},"review":{"@type":"Review","author":{"@type":"Person","name":"Rosa Diaz Sandoval"},"reviewRating":{"@type":"Rating","ratingValue":"5","bestRating":"5"},"reviewBody":"Writing texts with correct English grammar and style is not an easy task for people who speak other languages. Sometimes you cannot find little mistakes in your document without help and moreover for academic writing. I tried Trinka AI as a tool of automatic correction and was quite glad with the suggested corrections and the feedback. With the feedback, you understand why the suggested change must be taken into account."}},{"@type":"FAQPage","mainEntity":[{"@type":"Question","name":"Where can I check whether my sentence is correct?","acceptedAnswer":{"@type":"Answer","text":"Just paste your content in the editor available on this page and click on Check my writing. Trinka will highlight all the sentence structure and usage errors and provide accurate contextual suggestions."}},{"@type":"Question","name":"How can I check the grammar of my sentence?","acceptedAnswer":{"@type":"Answer","text":"Using Trinka's Sentence Checker tool, you can review your writing for grammar and punctuation errors, word usage, and much more with just a few simple clicks."}}]},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka AI","item":"https://www.trinka.ai"},{"@type":"ListItem","position":2,"name":"Sentence Checker","item":"https://www.trinka.ai/sentence-checker"}]},{"@type":"SoftwareApplication","name":"Sentence Checker","operatingSystem":"Web-based","applicationCategory":"Writing Tools","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.8","reviewCount":"189"},"offers":{"@type":"Offer","price":"0","priceCurrency":"USD","availability":"Online","url":"https://www.trinka.ai/sentence-checker"}}]}
    `;
    this._renderer2.appendChild(this._document.head, script);
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  ngAfterViewInit() {
    const observer = new MutationObserver(() => {
      const editors = document.querySelectorAll('.editor');
  
      editors.forEach((editor) => {
        editor.setAttribute('data-gramm', 'false');
        editor.setAttribute('data-gramm_editor', 'false');
        editor.setAttribute('data-enable-grammarly', 'false');
      });
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

}
